import React from "react";
import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  container: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    verticalAlign: "top",
    marginLeft: "8px",
    backgroundColor: "#f9f9f9",
    padding: "4px",
    borderRadius: "4px",
    border: "1px solid #eee",
  },
  item: {
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #333",
    backgroundColor: "#fff",
    fontFamily: "monospace",
    fontWeight: "bold",
    fontSize: "0.85rem",
    marginBottom: "-1px",
    zIndex: 1,
  },
  label: {
    fontSize: "0.6rem",
    textTransform: "uppercase",
    marginBottom: "2px",
    color: "#666",
  },
});

export default function StackVisualizer({ content }) {
  const classes = useStyles();

  const cleanContent = String(content || "").replace(/[[\], \t]/g, "");

  let items;
  if (cleanContent.length === 0) {
    items = ["λ"];
  } else {
    items = cleanContent.split("").reverse();
  }

  return (
    <Box className={classes.container}>
      {items.map((char, index) => (
        <div key={index} className={classes.item}>
          {char}
        </div>
      ))}

      <div style={{ width: "28px", height: "3px", backgroundColor: "#333" }} />
    </Box>
  );
}
